import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepDetailsHeaderIconComponent } from 'components/certificate/step-details-header-icon/step-details-header-icon.component';
import { StatusIndicatorModule } from 'components/status-indicator/status-indicator.module';
import { RejectedHintModule } from 'components/hint/rejected-hint/rejected-hint.module';
import { StepIconModule } from 'components/step-icon/step-icon.module';

@NgModule({
  imports: [CommonModule, StatusIndicatorModule, RejectedHintModule, StepIconModule],
  exports: [StepDetailsHeaderIconComponent],
  declarations: [StepDetailsHeaderIconComponent],
  providers: [],
})
export class StepDetailHeaderIconModule {}
